import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/iconminiwhite.png'
import _imports_1 from '@/assets/iconminiblack.png'
import _imports_2 from '@/assets/iconwhite.png'
import _imports_3 from '@/assets/iconblack.png'


const _withScopeId = n => (_pushScopeId("data-v-074d5bd3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "menu-container"
}
const _hoisted_2 = { class: "headertitle" }
const _hoisted_3 = { class: "flex-none" }
const _hoisted_4 = {
  key: 0,
  class: "headerlogo",
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  class: "headerlogo",
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = {
  key: 2,
  class: "headerlogo",
  src: _imports_2,
  alt: ""
}
const _hoisted_7 = {
  key: 3,
  class: "headerlogo",
  src: _imports_3,
  alt: ""
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "title-wrapper"
}
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex gap-2" }
const _hoisted_13 = { class: "flex align-items-center" }
const _hoisted_14 = { class: "flex align-items-center" }
const _hoisted_15 = {
  key: 2,
  class: "flex flex-column align"
}
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = { class: "flex flex-column p-4 row-gap-2" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = { class: "text-sm" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "pt-2" }
const _hoisted_23 = { class: "pt-2" }
const _hoisted_24 = {
  class: "modal-title",
  slot: "modal-title"
}

import { computed } from '@vue/reactivity';
import { getGlobalProps } from '@rednex/gateway_core';
import { inject } from 'vue';
import { onBeforeUnmount } from 'vue';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { watch } from 'vue';
//--- Function imports

//### Service imports
import { AlertService } from '@rednex/gateway_core';
import LoginService from '@/account/login.service';
import UserManagementService from '@/admin/user-management/user-management.service';
//--- Service imports

//### Model imports
import { languageOptions } from '@/shared/model/option-constants';
//--- Model imports

//### Component imports
import ChangePassword from '@/account/change-password/change-password-modal.vue';
import SearchComponent from '@/core/search/search.vue';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'navigation-bar',
  setup(__props) {

//### Function imports
const alertService = inject<AlertService>('alertService');
const loginService = inject<LoginService>('loginService');
const userManagementService = inject<UserManagementService>('userManagementService');

const globalProps = getGlobalProps();
const router = useRouter();
const store = useStore();
//--- Setup

//### Store/Reactive Data
const applicationIsBusy = computed(() => store.getters.applicationIsBusy);
const avatar = computed(() => store.getters.currentUser?.avatar);
const backButtonRoute = computed(() => store.getters.backButtonRoute);
const cardTitle = computed(() => store.getters.cardTitle);
const currentLanguage = computed(() => store.getters.currentLanguage);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const isDesktopDevice = computed(() => store.getters.isDesktopDevice);
const isPhoneDevice = computed(() => store.getters.isPhoneDevice);
const loginName = computed(() => store.getters.currentUser?.login);
const menuExpanded = computed(() => store.getters.menuExpanded);
const showBackButton = computed(() => store.getters.showBackButton);
const themeMode = computed(() => store.getters.themeMode);

watch(
  () => {
    return store.getters.cardNavbarComponent;
  },
  cardNavbarComponent => {
    if (cardNavbarComponent) {
      ctxNavbar = cardNavbarComponent.navbarTemplate;
    }
  },
);
//--- Store/Reactive Data

//### Variables const let
const menuUserSettings = ref();
const modalChangePasswordVisible = ref(false);
const themeOptions = ref([
  { icon: 'fa-regular fa-moon', value: 'dark' },
  { icon: 'fa fa-lightbulb', value: 'light' },
]);

let ctxNavbar;
//--- Variables const let

//### Component Lifecycle
onMounted(() => {
  globalProps.emitter.on('close-password-modal', () => (modalChangePasswordVisible.value = false));
});

onBeforeUnmount(() => {
  globalProps.emitter.off('close-password-modal');
});
//--- Component Lifecycle

//### Functions
function changeLanguage(event: any): void {
  const newLanguage = event.value;
  if (newLanguage) {
    const currentUser = store.getters.currentUser;
    currentUser.langKey = newLanguage;

    userManagementService
      .update(currentUser)
      .catch(error => {
        alertService.showHttpError(globalProps, error);
      })
      .then(res => {
        if (res && res.data && res.data.langKey) {
          store.commit('currentLanguage', newLanguage);
        }
      });
  }
}

function switchTheme(event): void {
  const { value } = event;

  if (value && themeMode.value !== value) {
    store.commit('changeTheme', themeMode.value === 'light' ? 'dark' : 'light');
  }
}

function handlePasswordChangeClick() {
  modalChangePasswordVisible.value = true;
}

function handleLogoutClick() {
  loginService.logout().then(response => {
    store.commit('logout');
    window.location.href = response.data.logoutUrl;
  });
}

function handleClickBack() {
  if (backButtonRoute.value) {
    router.push(backButtonRoute.value);
  } else {
    window.history.back();
  }
}

const toggleUserMenu = event => {
  menuUserSettings.value.toggle(event);
};

//--- Functions

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_unref(isAuthenticated))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            ((_unref(isPhoneDevice) || !_unref(menuExpanded)) && _unref(themeMode) === 'dark')
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_unref(isPhoneDevice) || !_unref(menuExpanded))
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : (_unref(menuExpanded) && _unref(themeMode) === 'dark')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                  : (_openBlock(), _createElementBlock("img", _hoisted_7))
          ]),
          (_unref(showBackButton))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_Button, {
                  onClick: handleClickBack,
                  class: "p-button-text"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: "arrow-left" })
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : _createCommentVNode("v-if", true),
          (_unref(cardTitle))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t(_unref(cardTitle))), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_unref(store).getters.inList)
            ? (_openBlock(), _createBlock(SearchComponent, { key: 0 }))
            : _createCommentVNode("v-if", true),
          (_unref(store).getters.cardNavbarComponent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_unref(ctxNavbar))
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_unref(applicationIsBusy))
              ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                  key: 0,
                  animationDuration: "4s",
                  strokeWidth: "4",
                  style: {"width":"33px","height":"33px"}
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              onClick: toggleUserMenu,
              class: _normalizeClass(`p-link flex align-items-center p-2 ${!_unref(isPhoneDevice) ? 'mr-4' : ''} text-color`)
            }, [
              (_unref(avatar))
                ? (_openBlock(), _createBlock(_component_Avatar, {
                    key: 0,
                    class: "mr-2 avatar avatar-circle",
                    image: _unref(avatar),
                    shape: "circle"
                  }, null, 8 /* PROPS */, ["image"]))
                : _createCommentVNode("v-if", true),
              (!_unref(avatar))
                ? (_openBlock(), _createBlock(_component_Avatar, {
                    key: 1,
                    class: "mr-2 default-user-avatar avatar avatar-circle",
                    icon: "pi pi-user",
                    shape: "circle"
                  }))
                : _createCommentVNode("v-if", true),
              (_unref(isDesktopDevice))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(loginName)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */),
            _createVNode(_component_Menu, {
              ref_key: "menuUserSettings",
              ref: menuUserSettings,
              id: "overlay_layout_menu",
              class: "mt-2",
              popup: true
            }, {
              start: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  (!_unref(isDesktopDevice))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(loginName)), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('setting.theme')), 1 /* TEXT */),
                    _createVNode(_component_SelectButton, {
                      modelValue: _unref(themeMode),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(themeMode) ? (themeMode).value = $event : null)),
                      onChange: switchTheme,
                      options: themeOptions.value,
                      optionValue: "value"
                    }, {
                      option: _withCtx((slotProps) => [
                        _createElementVNode("i", {
                          class: _normalizeClass(slotProps.option.icon)
                        }, null, 2 /* CLASS */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('setting.language')), 1 /* TEXT */),
                    _createVNode(_component_SelectButton, {
                      modelValue: _unref(currentLanguage),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentLanguage) ? (currentLanguage).value = $event : null)),
                      onChange: changeLanguage,
                      options: _unref(languageOptions),
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_Button, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePasswordChangeClick())),
                      label: _ctx.$t('menu.account.changePassword'),
                      class: "p-button-text",
                      icon: "fa fa-key",
                      style: {"padding":"0"},
                      type: "button"
                    }, null, 8 /* PROPS */, ["label"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_Button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (handleLogoutClick())),
                      label: _ctx.$t('menu.logout'),
                      class: "p-button-text",
                      icon: "fa fa-arrow-right-from-bracket",
                      style: {"padding":"0"},
                      type: "button"
                    }, null, 8 /* PROPS */, ["label"])
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            }, 512 /* NEED_PATCH */)
          ])
        ]),
        _createCommentVNode(" eslint-disable vue/no-v-model-argument "),
        _createVNode(_component_Dialog, {
          visible: modalChangePasswordVisible.value,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((modalChangePasswordVisible).value = $event)),
          contentClass: 'default-dialog',
          draggable: false,
          modal: ""
        }, {
          header: _withCtx(() => [
            _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.$t('menu.account.changePassword')), 1 /* TEXT */)
          ]),
          default: _withCtx(() => [
            _createVNode(ChangePassword)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["visible"])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})